import { ValidatorList } from '../../validator/validatorList';
import { CheckedGroupes } from '../../validator/checkedGroupes';
export class CheckedElement {
    constructor(element) {
        this.element = element;
    }
    getValidator() {
        const list = new ValidatorList();
        if (this.element.hasAttribute('required')) {
            list.add(new CheckedGroupes(this.element.name, this.element.value, this.element, this.element.requiredErrorMsg ? this.element.requiredErrorMsg : ''));
        }
        return list;
    }
}
//# sourceMappingURL=checkedElement.js.map